module.exports = __webpack_public_path__ + "img/logo-ispace-finances.3c9012aa.svg";